var Promise = require('es6-promise').Promise;
import { polyfill } from 'es6-promise'; polyfill();
import './components/globalInits';
import './components/tabbable-nav';
import './components/tablet-nav-controls';
import './components/mobile-menu';
import './components/login-modal';
import './components/member-dropdown';
import './components/listing';
import './components/left-nav';
import './components/table-sort';
import './components/memberlist-modal';
import './components/pagination';
import './components/no-results';
import './components/multiselect';
import './components/form-to-top';
import './components/header-notifications';



// WEBPACK FOOTER //
// ./CMS/NationalGuild/src/js/scripts.js